<div class="instructions" *ngIf="task.instructionsTitle">
  <om-profile-bubble size="small" [profile]="task.provider"></om-profile-bubble>
  <h5>{{ task.instructionsTitle }}</h5>
  <p *ngIf="task.instructions">{{ task.instructions }}.</p>
</div>

<div class="section" *ngIf="task.isAssigned">
  <om-profile-bubble size="small" [profile]="task.provider"></om-profile-bubble>
  <h5 class="pr-0">{{ task.content.question }}</h5>
</div>

<div class="section p-0" *ngIf="task.isAssigned">
  <div class="message-body mb-3">
    <textarea
      placeholder="Reply to message"
      class="form-control form-input w-100 h-100 message"
      [(ngModel)]="task.content.message"
    >
    </textarea>
  </div>

  <button
    [disabled]="task.content.message.length == 0 || submitting"
    [hidden]="task.isCompleted"
    class="btn btn-lg btn-primary btn-block mb-3"
    (click)="submitMessage()"
  >
    Send Message
  </button>
</div>

<div>
  <h5>{{ task.taskOptionsTitle }}</h5>
  <p>{{ task.taskOptionsDescription }}</p>
</div>
